import { render } from "./messenger-chat-plugin.vue?vue&type=template&id=17f39226&scoped=true"
import script from "./messenger-chat-plugin.vue?vue&type=script&lang=js"
export * from "./messenger-chat-plugin.vue?vue&type=script&lang=js"

import "./messenger-chat-plugin.vue?vue&type=style&index=0&id=17f39226&lang=css"
import "./messenger-chat-plugin.vue?vue&type=style&index=1&id=17f39226&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f39226"]])

export default __exports__